
import React, { useEffect, useState } from "react";
import './App.css';
import BuildingPage from  "./pages/building-page/building-page"
import Home from './pages/home/home';

function App() {

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();

    window.addEventListener("resize", checkMobile); 

    return () => window.removeEventListener("resize", checkMobile);
  }, []);
  
  return (
    <>
      {isMobile ? <Home /> : <Home />}
    </>
  );
}

export default App;
